/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type Suffixes = 'Mr.' | 'Ms.' | 'Mrs.' | 'Sr.' | 'Jr.' | 'Dr.' | 'PhD.' | 'Esq.' | '';

export const Suffixes = {
    Mr: 'Mr.' as Suffixes,
    Ms: 'Ms.' as Suffixes,
    Mrs: 'Mrs.' as Suffixes,
    Sr: 'Sr.' as Suffixes,
    Jr: 'Jr.' as Suffixes,
    Dr: 'Dr.' as Suffixes,
    PhD: 'PhD.' as Suffixes,
    Esq: 'Esq.' as Suffixes,
    Empty: '' as Suffixes
};